import * as React from 'react';
import TokenizedCreditCardFields from './tokenized_credit_card_fields';
import { ITokenizedCreditCardData } from './card_data';

interface IProps {
  onTokenizedFieldUpdate(attributes: Partial<ITokenizedCreditCardData>): void;
  onCardDataUpdate?(attributes: Partial<ICardData>): void;
  tokenizedFields: ITokenizedCreditCardData;
  cardData: Partial<ICardData>;
}

export interface ICardData {
  cardholderName: string;
  cardType: string;
  last4: string;
}

const TokenizedCreditCardHiddenFields: React.StatelessComponent<IProps> = props => (
  <div>
    <TokenizedCreditCardFields
      onTokenizedFieldUpdate={props.onTokenizedFieldUpdate}
      onCardDataUpdate={props.onCardDataUpdate}
    />
    <input
      type="hidden"
      name="credit_card[tokenized_data][encryptedCardNumber]"
      value={props.tokenizedFields.encryptedCardNumber}
    />
    <input
      type="hidden"
      name="credit_card[tokenized_data][encryptedExpiryMonth]"
      value={props.tokenizedFields.encryptedExpiryMonth}
    />
    <input
      type="hidden"
      name="credit_card[tokenized_data][encryptedExpiryYear]"
      value={props.tokenizedFields.encryptedExpiryYear}
    />
    <input
      type="hidden"
      name="credit_card[tokenized_data][encryptedSecurityCode]"
      value={props.tokenizedFields.encryptedSecurityCode}
    />
    <input
      type="hidden"
      name="credit_card[type]"
      value={props.cardData.cardType}
    />
    <input
      type="hidden"
      name="credit_card[last_4]"
      value={props.cardData.last4}
    />
  </div>
);

export default TokenizedCreditCardHiddenFields;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/tokenized_credit_card_hidden_fields.tsx